import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";

import { useApiClient } from "../api";

export const AcademicYearSelect = ({
  value,
  onChange,
  allowAll = true,
  disabled = false,
  size,
  sx,
}) => {
  const ApiClient = useApiClient();
  const [academicYears, setAcademicYears] = useState([]);

  useEffect(() => {
    let active = true;

    const loadAcademicYears = async () => {
      if (!ApiClient.schools.getAcademicYears) {
        return;
      }
      try {
        const response = await ApiClient.schools.getAcademicYears();
        if (active) {
          setAcademicYears(response?.academicYears || []);
        }
      } catch (error) {
        console.error("Failed to fetch academic years", error);
      }
    };

    loadAcademicYears();
    return () => {
      active = false;
    };
  }, [ApiClient.schools]);

  useEffect(() => {
    if (academicYears.length > 0 && value === undefined) {
      onChange(academicYears.find((year) => year.isCurrent)?.id || null);
    }
  }, [academicYears, onChange, value]);

  const selectValue = academicYears.some((year) => year.id === value)
    ? value
    : "";

  return (
    <FormControl size={size} disabled={disabled} sx={sx}>
      <InputLabel id="academic-year-filter-label">Academic Year</InputLabel>
      <Select
        labelId="academic-year-filter-label"
        label="Academic Year"
        value={selectValue}
        onChange={(event) => onChange(event.target.value || null)}
      >
        {allowAll && <MenuItem value="">All academic years</MenuItem>}
        {academicYears.map((year) => (
          <MenuItem key={year.id} value={year.id}>
            {year.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
